export default "__VITE_ASSET__BysyKLAn__"